import { render, staticRenderFns } from "./Unilateral-manul.vue?vue&type=template&id=39346f5a&scoped=true&"
import script from "./Unilateral-manul.vue?vue&type=script&lang=js&"
export * from "./Unilateral-manul.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39346f5a",
  null
  
)

export default component.exports